import { createAsync } from '@solidjs/router';
import { createMemo, ParentComponent } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { validateUser } from '~/server/user';

export const AuthGuard: ParentComponent = (props) => {
  createAsync(() => validateUser());

  const children = createMemo(() => props.children);

  return <Dynamic component={children} />;
};
